import { gql } from '@apollo/client';

export const FREEZE_ACCOUNT = gql`
  mutation FreezeAccount($reasons: [String]) {
    freezeAccount(reasons: $reasons) {
      ok
      errors
    }
  }
`;
